import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

import { AuthProvider } from "@/context/AuthContext";
import { WebSocketProvider } from "@/context/WebSocketContext";
import { AppConfigProvider } from "@/context/AppConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <WebSocketProvider>
        <AppConfigProvider>
          <App />
        </AppConfigProvider>
      </WebSocketProvider>
    </AuthProvider>
  </React.StrictMode>
);